import { CheckCircleFilled } from '@ant-design/icons';
import { Modal, Progress } from 'antd';
import { GUIDE_CHECKLIST } from './guideConfig';
import { GuideTarget } from './types';

type PropsType = {
  target: GuideTarget | null;
  completedIds: string[];
  onClose: () => void;
  onSelect: (item: (typeof GUIDE_CHECKLIST)[number]) => void;
};

const GuideModal = ({ target, completedIds, onClose, onSelect }: PropsType) => {
  if (!target) return null;

  const progressPercent = Math.round((completedIds.length / GUIDE_CHECKLIST.length) * 100);
  const allDone = progressPercent === 100;

  return (
    <Modal open={!!target} onCancel={onClose} footer={null} width="90vw" centered destroyOnClose styles={{ body: { padding: 20 } }}>
      <div className="flex relative" style={{ height: '90vh' }}>
        <div className="absolute right-0 bottom-0 w-[260px] max-h-[220px] shrink-0 bg-[#1B73E8] text-white p-4 overflow-y-auto rounded-md">
          <p className="font-semibold mb-1">{allDone ? "You're all set!" : 'Getting Started'}</p>
          <Progress percent={progressPercent} showInfo={false} strokeColor="#fff" trailColor="rgba(255,255,255,0.3)" />
          {allDone && <p className="text-sm mt-2 opacity-90">You&apos;ve completed the full guide. Revisit any step anytime.</p>}
          <ul className="mt-3 space-y-2">
            {GUIDE_CHECKLIST.map((item) => {
              const done = completedIds.includes(item.id);
              const active = item.flow === target.flow && item.stepIndex === target.step;
              return (
                <li key={item.id}>
                  <button
                    type="button"
                    onClick={() => onSelect(item)}
                    className={`flex items-center gap-2 text-sm w-full text-left rounded-md px-2 py-1 -mx-2 ${active ? 'bg-white/15' : ''} hover:bg-white/10`}
                  >
                    <CheckCircleFilled style={{ color: done ? '#FFD43B' : 'rgba(255,255,255,0.4)' }} />
                    <span className={done ? 'line-through opacity-80' : ''}>{item.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
        <iframe
          key={`${target.flow}-${target.step}`}
          title="TrackForce guided demo"
          src={`${window.location.origin}/full-guide-demo/${target.flow}?step=${target.step}`}
          style={{ width: '100%', height: '100%', border: 'none', display: 'block', }}
        />
      </div>
    </Modal>
  );
};

export default GuideModal;
